module.exports = __webpack_public_path__ + "static/img/screens.2c54ca0.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/svg/screens.svg
// module id = JDPn
// module chunks = 48